import { render, staticRenderFns } from "./CoreCategoryDetail.vue?vue&type=template&id=00295362&scoped=true"
import script from "./CoreCategoryDetail.vue?vue&type=script&lang=js"
export * from "./CoreCategoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00295362",
  null
  
)

export default component.exports